import {AddressModel} from '@service/models/address.model';
import {ResidenceModel} from '@service/models/residence.model';
import {EmploymentModel} from '@service/models/employment.model';
import {IdentityModel} from '@service/models/identity.model';
import {TradelineModel} from '@service/models/tradeline.model';
import {ApplicantType} from '@service/enum/process-state.enum';

export class ApplicantModel {
    applicationId: number;
    applicantId: number;
    applicantType: ApplicantType;   // P, S, BS etc
    firstName: string;
    customerIdentifier: string;
    lastName: string;
    middleName: string;
    surname: string;
    dob: string;
    ssn: string;
    email: string;
    citizenship: string;
    citizenshipStatus: string;
    citizenshipStatusDesc: string;
    citizenInd: boolean;  // Yes - US, No - Non US
    permanentResident: boolean;  // Yes - PR, No - Non PR
    specialOfficer: string;
    primaryPhone: string;
    homePhone: string;
    workPhone: string;
    userName: string;
    custStatus: number; // 0 = Active | 1 = Suspended | Pending = 2
    dateOfBirth: Date;
    category: string; // 0 = Business | 1 = Individual
    relevancyScore: number;
    creditTier: string;
    housingCost: number;
    income: number;
    militaryActiveDutyIndicator: boolean; // 0 = Non - Military | 1 = Active | 2 = Retired
    maritalStatus: string;
    spouseName: string;
    consent: string;
    address: AddressModel;
    residence: ResidenceModel;
    employers: EmploymentModel[];
    identity: IdentityModel[];
    tradelines: TradelineModel[];
    relationShipToPrimaryApplicant: string;
    relationShipToFamilyMember: string;
    familyMemberFirstName: string;
    familyMemberLastName: string;
    familyMemberDateOfBirth: any;
    familyMemberCustomerIdentifier: string;
    mothersMaidenName: string;
    member: boolean;
    membershipEligibilityCriteria: string;
    affiliatedSponsorOrganization: string;
    affiliatedSponsorOrganizationCode: string;
    affiliatedSponsorOrganizationMemberNumber: string;
    affiliatedSponsorOrganizationEmployeeTitle: string;
    additionalAddressDetails: AddressModel[];
    pastResidenceDetails: ResidenceModel[];

    drivingLicenseNumber: string;
    drivingLicenseState: string;
    idType: string;
    idIssuer: string;
    idNumber: string;
    idIssueDate: string | Date;
    idExpDate: string | Date;

    // Added inMyConsent Flow
    loanPurpose: string;
    offerStatus: string;
    productName: string;
    productType: string;
    status: string;

    // beneficiary relation
    beneficiaryRelation: string;

    // company model data
    option: string;
    companyLegalName: string;
    companyTaxIdentificationNumber: string;
    companyEntityType: string;
    companyWebSite: string;
    companyIndustry: string;
    businessDescription: string;
    businessLength: number;
    employeeCount: number;
    exclusionConditions: any;
    title: string;
    controllingManagerType: string;
    percentageOwnership: number;
    stateOfBusinessFormation: string;

    // Natural-person beneficial owners of an entity-type owner, one level down.
    businessOwners: BusinessOwnerModel[];

    prospectEncryptedKey: string;
    addedToCore: boolean;
    derosDate: string;
    studentId: string;
    extendedAttributes: any;

    constructor() {
        this.address = new AddressModel();
        this.residence = new ResidenceModel();
        this.identity = [];
        this.employers = [];
        this.applicantType = ApplicantType.PRIMARY;
        this.category = 'INDIVIDUAL';
        this.relevancyScore = 0;
        this.citizenInd = false;
        this.militaryActiveDutyIndicator = false;
        this.pastResidenceDetails = [];
        this.additionalAddressDetails = [];
    }
}

/** Outbound shape for one ApplicantModel.businessOwners entry — only what the nested BO form collects. */
export interface BusinessOwnerModel {
    applicantId?: number;
    category: string;
    firstName: string;
    lastName: string;
    title: string;
    percentageOwnership: number;
    institutionCode: string;
}

export class ReferenceApplicantModel {
    firstName: string;
    lastName: string;
    email: string;
    primaryPhone: string;
    address: AddressModel;
    constructor() {
        this.address = new AddressModel();
    }
}
